var step17_tm, step17_o, step17_h, step17_t;

$(document).ready(function () {
	var ir1, ir2, ir3 = 0;
	if ($('#step17').length) {
		if ($('body').hasClass('home')) {
			$('#step17 #plan_drop a').hover(function () {
				step17_t = $(this).attr('rel');
				if (step17_tm) window.clearTimeout(step17_tm);
				$('#step17 .item').removeClass('item_do');
				$('#step17 .item span').not('.r' + step17_t).parent().addClass('item_do');
				//step17_o = $('#step17 .item:first');
				//while (step17_o.length && step17_o.find('span').hasClass('r' + step17_t)) step17_o = step17_o.next();
				step17_tm = window.setTimeout(step17_func, 50);
			}, function () {
				$('#step17 .item').removeClass('item_do');
			});
		} else {
			if ($('#step17 .item').length && $('#step17 .item_hid').length) window.setInterval(function () {
				ir1 = Math.floor(Math.random() * ($('#step17 .item').length - 0.01)) + 1;
				while (ir1 == ir3) ir1 = Math.floor(Math.random() * ($('#step17 .item').length - 0.01)) + 1;
				ir3 = ir1;
				ir2 = Math.floor(Math.random() * ($('#step17 .item_hid').length - 0.01)) + 1;
				$('#step17 .item:nth-child(' + ir1 + ') span').appendTo($('#step17 .item_hid:nth-child(' + ir2 + ')'));
				$('#step17 .item_hid:nth-child(' + ir2 + ') span:first').appendTo($('#step17 .item:nth-child(' + ir1 + ')')).addClass('ani');
				window.setTimeout(function () {
					$('#step17 .item span').removeClass('ani');
				}, 100)
			}, 1000);
		}
	}
});

function step17_func() {
	$('#step17 .item span').removeClass('ani');
	step17_o = $('#step17 .item_do');
	if (!step17_o.length) return;
	step17_o = $(step17_o.get(Math.floor(Math.random() * (step17_o.length - 0.01))));
	if (!step17_o.length) return;
	step17_h = $('#step17 .item_hid span.r' + step17_t).parent();
	if (!step17_h.length) return;
	step17_h = $(step17_h.get(Math.floor(Math.random() * (step17_h.length - 0.01))));
	if (!step17_h.length) return;
	//step17_o.css({background: 'red'});
	step17_h.find('span').appendTo(step17_o); //.removeClass('ani');
	step17_o.removeClass('item_do').find('span:first').appendTo(step17_h).addClass('ani');
	//step17_o = step17_o.next();
	//while (step17_o.length && step17_o.find('span').hasClass('r' + step17_t)) step17_o = step17_o.next();
	step17_tm = window.setTimeout(step17_func, 100);
}